<template>
  <b-modal :id="id"
             hide-footer 
           size="lg"
           title = "Order Detail"
  >
   order detail
  </b-modal>
</template>

<script>
  import notification from '@/components/common/notification'
  export default {
    props: {
        id:{
            type: String
        }
    },
    data () {
      return {
        name: ''
      }
    },
    methods: {
      create (evt) {
       
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/orderHistory/MMaOrderDetailModal.vue